import { RootState } from '../store';
import { createAsyncThunk } from '@reduxjs/toolkit';
import apiVRR from '../../libs/axios/apis';
import endPoints from '../../services/endpoints';
import { notify } from '../app/appSlice';
import { TEditMPDRequest, TMediaPlan, TMediaPlanPixel } from './types';
import { TMediaPlanDetails } from '../../micro_front_end/media_plan/media_plan_details/types';
import { TUrlError } from '../creativeAnalytics/creativeImportVideo/types';

export const fetchMediaPlans = createAsyncThunk(
  'mediaPlanGallery/fetchMediaPlans',
  async (_, { getState }) => {
    const currentBrandId = (getState() as any).setting.vrr_preferences
      .current_brand_id;
    const endpointURL = endPoints.MEDIA_PLAN_GALLERY.MEDIA_PLAN(currentBrandId);
    const response = await apiVRR('v2').get(endpointURL);

    return response.data;
  }
);

export const fetchMediaPlan = createAsyncThunk(
  'mediaPlanGallery/fetchMediaPlan',
  async (param: { mediaPlanId: number | string }, { getState }) => {
    const currentBrandId = (getState() as any).setting.vrr_preferences
      .current_brand_id;
    const endPointURL = endPoints.MEDIA_PLAN_GALLERY.MEDIA_PLAN_DETAILS(
      currentBrandId,
      typeof param.mediaPlanId === 'number'
        ? param.mediaPlanId.toString()
        : param.mediaPlanId
    );

    const response = await apiVRR('v2').get(endPointURL);

    return response.data;
  }
);

export const editMediaPlanDetails = createAsyncThunk(
  'mediaPlanGallery/editMediaPlanDetails',
  async (params: TEditMPDRequest, { dispatch, getState }) => {
    const mediaPlanId = (getState() as any).mediaPlanGallery.mediaPlan.id;
    const currentBrandId = (getState() as any).setting.vrr_preferences
      .current_brand_id;
    const endpointURL = endPoints.MEDIA_PLAN_GALLERY.MEDIA_PLAN_DETAILS(
      currentBrandId,
      mediaPlanId
    );
    const response = await apiVRR('v2').patch(endpointURL, params);

    if (response.status >= 200) {
      dispatch(notify({ type: 'success' }));
    }

    return response.data;
  }
);

export const fetchPixels = createAsyncThunk(
  'mediaPlanGallery/fetchPixels',
  async (_, { getState }) => {
    const currentBrandId = (getState() as any).setting.vrr_preferences
      .current_brand_id;
    const endPointURL =
      endPoints.MEDIA_PLAN_GALLERY.MEDIA_PLAN_PIXELS(currentBrandId);

    const response = await apiVRR('v2').get(endPointURL);

    return response.data;
  }
);

export const addNewMediaPlan = createAsyncThunk(
  'mediaPlanGallery/addNewMediaPlan',
  async (_, { getState }) => {
    const currentBrandId = (getState() as any).setting.vrr_preferences
      .current_brand_id;
    const endPointURL = endPoints.MEDIA_PLAN_GALLERY.MEDIA_PLAN(currentBrandId);

    const response = await apiVRR('v2').post(endPointURL);

    return response.data;
  }
);

export const getMediaPlans = (
  state: RootState
): TMediaPlan[] | undefined | [] => state.mediaPlanGallery.mediaPlans;

export const getMediaPlan = (state: RootState): TMediaPlanDetails | undefined =>
  state.mediaPlanGallery.mediaPlan;

export const getMediaPlanGenders = (
  state: RootState
): TMediaPlanDetails['genders'] | [] =>
  state.mediaPlanGallery.mediaPlan?.genders ?? [];

export const getMediaPlanAges = (
  state: RootState
): TMediaPlanDetails['ages'] | [] =>
  state.mediaPlanGallery.mediaPlan?.ages ?? [];

export const getMediaPlanRedirections = (
  state: RootState
): TMediaPlanDetails['redirections'] | undefined =>
  state.mediaPlanGallery.mediaPlan?.redirections ?? undefined;

export const getMediaPlanCallToActions = (
  state: RootState
): TMediaPlanDetails['call_to_actions'] | undefined =>
  state.mediaPlanGallery.mediaPlan?.call_to_actions ?? undefined;

export const getMediaPlanZones = (
  state: RootState
): TMediaPlanDetails['zones'] | undefined =>
  state.mediaPlanGallery.mediaPlan?.zones ?? undefined;

export const getMediaPlanTargets = (
  state: RootState
): TMediaPlanDetails['targets'] | undefined =>
  state.mediaPlanGallery.mediaPlan?.targets ?? undefined;

export const getPixels = (state: RootState): TMediaPlanPixel[] | undefined =>
  state.mediaPlanGallery.pixels ?? undefined;

export const getMediaPlanErrors = (state: RootState): TUrlError[] | undefined =>
  state.mediaPlanGallery.errors;

export const getIsComplete = (state: RootState): boolean =>
  state.mediaPlanGallery.isComplete;
